import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';

import { User } from '@classes/licence/user';
import { Language } from '@classes/language';

@Component({
    selector: 'app-account-parameters',
    templateUrl: './account-parameters.component.html',
    styleUrls: ['./account-parameters.component.scss']
})
export class AccountParametersComponent implements OnInit {
    parameterForm: FormGroup;
    isLoading: boolean;
    user: User;
    langages: Language[];

    constructor(
        private fb: FormBuilder
    ) { }

    ngOnInit() {
        this.initForm();
    }

    private initForm(): void {
        this.parameterForm = this.fb.group({
            lang: ['']
        });
    }
}
